import { mount } from 'svelte'
import PublicCoupon from '../../components/coupons/PublicCoupon.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('coupons-public-app')
  if (el) {
    mount(
      PublicCoupon,
      {
        target: el,
        props: {
          coupon: el.dataset.coupon
        },
      })
  }
})
